import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';

export interface IDeclineResult {
    declined: boolean;
    reason: string;
}

// NEOIQ-2701: no decline/audit-logging endpoint was shared by backend — per the ticket, declining
// moves no funds and keeps the voucher ACTIVE, so this is implemented as local-only for now. If an
// endpoint to record the decline reason turns up, wire it into voucher-details.component.ts#openDecline
// using the reason captured here.
const OTHER_REASON = 'Other';
export const DECLINE_REASONS = ['Insufficient cash on hand', 'Customer identity could not be verified', 'Customer cancelled the request', OTHER_REASON];

@Component({
    selector: 'app-decline-confirm-modal',
    standalone: true,
    templateUrl: './decline-confirm-modal.component.html',
    styleUrls: ['./decline-confirm-modal.component.scss'],
    imports: [AngularMaterialModule, ReactiveFormsModule],
})
export class DeclineConfirmModalComponent {
    protected readonly reasons = DECLINE_REASONS;
    protected reasonControl = new FormControl(DECLINE_REASONS[0]);
    // Node 8456:128125 — selecting "Other" reveals a free-text textarea in place of a fixed reason.
    protected otherReasonTextControl = new FormControl('');

    constructor(private readonly dialogRef: MatDialogRef<DeclineConfirmModalComponent, IDeclineResult>) {}

    protected get isOtherSelected(): boolean {
        return this.reasonControl.value === OTHER_REASON;
    }

    protected back(): void {
        this.dialogRef.close();
    }

    protected decline(): void {
        const reason = this.isOtherSelected ? (this.otherReasonTextControl.value ?? '').trim() : this.reasonControl.value ?? '';
        this.dialogRef.close({ declined: true, reason });
    }
}
